/**
 * iCure Data Stack API Documentation
 * The iCure Data Stack Application API is the native interface to iCure. This version is obsolete, please use v2.
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Measure } from './Measure'
import { Medication } from './Medication'
import { Service } from './Service'
import { TimeSeries } from './TimeSeries'

/**
 * Information contained in the service. Content is localized, using ISO language code as key
 */
import { b64_2ab } from './ModelHelper'
export class Content {
  constructor(json: JSON | any) {
    let binaryData: { binaryValue?: ArrayBuffer } = {}
    if (!!json?.binaryValue) {
      if (typeof json.binaryValue === 'string') {
        binaryData.binaryValue = b64_2ab(json.binaryValue)
      } else if (json.binaryValue instanceof ArrayBuffer || ArrayBuffer.isView(json.binaryValue)) {
        binaryData.binaryValue = json.binaryValue
      } else {
        throw new Error(`Invalid type for binaryValue: ${typeof json.binaryValue}`)
      }
    }
    Object.assign(this as Content, json, binaryData)

    if (!!json?.measureValue) {
      this.measureValue = new Measure(json.measureValue)
    }

    if (!!json?.compoundValue) {
      this.compoundValue = json.compoundValue.map((service: JSON | any) => new Service(service))
    }
  }

  stringValue?: string
  numberValue?: number
  booleanValue?: boolean
  instantValue?: number
  /**
   * Value as date. The format could have a all three (day, month and year) or values on any of these three, whatever is known.
   */
  fuzzyDateValue?: number
  binaryValue?: ArrayBuffer
  /**
   * Linked document.
   */
  documentId?: string
  measureValue?: Measure
  medicationValue?: Medication
  timeSeries?: TimeSeries
  compoundValue?: Array<Service>
  ratio?: Array<Measure>
  range?: Array<Measure>
}
